import Vue from 'vue'
import Router from 'vue-router'
import Step1 from '@/components/Step1'
import Step2 from '@/components/Step2'
import Step3 from '@/components/Step3'
import Step4 from '@/components/Step4'
import Step5 from '@/components/Step5'
import Step6 from '@/components/Step6'
import Calendar from '@/components/Calendar'
import FastSelect1 from '@/components/FastSelect1'
import FastSelect2 from '@/components/FastSelect2'

Vue.use(Router)

export default new Router({
     // mode: 'history',
    // base: '/',
    routes: [
        {
            path: '/',
            name: 'Step1',
            component: Step1
        },
        {
            path: '/step-1',
            name: 'init',
            component: Step1
        },
        {
            path: '/step-2',
            name: 'Step2',
            component: Step2,
            props: true
        },
        {
            path: '/step-3',
            name: 'Step3',
            component: Step3
        },
        {
            path: '/step-4',
            name: 'Step4',
            component: Step4
        },
        {
            path: '/step-5',
            name: 'Step5',
            component: Step5
        },
        {
            path: '/step-6',
            name: 'Step6',
            component: Step6
        },
        {
          path: '/prihlaseni',
        },
        {
          path: '/calendar',
          name: 'Calendar',
          component: Calendar
        },
        {
          path: '/fast-select-1',
          name: 'FastSelect1',
          component: FastSelect1
        },
        {
          path: '/fast-select-2',
          name: 'FastSelect2',
          component: FastSelect2,
            props: true
        },
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js